import { parse, format, JsonRpcError } from 'json-rpc-protocol';
import { decodeFromStr, encodeToStr } from "./coder";
export class JsonRPCServer {
    constructor(connector, methods) {
        this.connector = connector;
        this.methods = methods;
        this.connector.on('message', data => this.onRequest(data));
        this.connector.on('close', () => this.onClose());
    }
    onRequest(data) {
        const req = parse(data);
        if (req.type !== 'request')
            return;
        const method = this.methods[req.method];
        method(...req.params.map(param => decodeFromStr(param))).then(response => {
            const resp = format.response(req.id, encodeToStr(response));
            this.connector.send(resp);
        }).catch(err => {
            const resp = format.error(req.id, new JsonRpcError(String(err)));
            this.connector.send(resp);
        });
    }
    notify(type, data) {
        const notification = format.notification(type, data.map(encodeToStr));
        this.connector.send(notification);
    }
    onClose() {
    }
}
//# sourceMappingURL=JsonRPCServer.js.map